module.exports = __webpack_public_path__ + "img/stoerer_three.71caeeb6.png";